import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { Button } from '../ui/button';
import { ArrowLeft } from 'lucide-react';

export default function CareersHero() {
  const navigate = useNavigate();

  return (
    <section
      className="relative py-20 sm:py-28 bg-coal text-white overflow-hidden"
      data-testid="careers-hero"
    >
      <div className="noise-overlay" />
      <div className="max-w-6xl mx-auto px-4 sm:px-6 relative z-10">
        <Button
          variant="ghost"
          onClick={() => navigate('/')}
          className="text-white/60 hover:text-white hover:bg-white/10 mb-6 -ml-2 gap-2"
          data-testid="careers-back-button"
        >
          <ArrowLeft className="w-4 h-4" />
          Back to Home
        </Button>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <p className="kicker kicker-on-dark mb-4">Join Our Team</p>
          <h1 className="editorial-headline text-4xl sm:text-5xl lg:text-6xl text-white leading-[1.05] mb-6">
            Employment.
          </h1>
          <p className="text-lg sm:text-xl text-white/75 max-w-3xl leading-relaxed">
            Ozark Mountain Construction is an equal opportunity, non-union employer. We&rsquo;re
            always seeking skilled professionals who are interested in traveling to worksites
            across the United States. We are a well-established company that offers an opportunity
            for advancement and growth.
          </p>
        </motion.div>
      </div>
    </section>
  );
}
